// extracted by mini-css-extract-plugin
module.exports = {"Snippet":"ib_a bag_po"};